/**
 * Clears all session-based artist data from stores.
 * Call when the agency switches to a different artist so that GET APIs are hit again
 * for the new artist instead of showing stale data from the previous one.
 * Also used on logout to clear artist-scoped caches.
 */
import { usePersonalDetailsStore } from '@/stores/personalDetailsStore';
import { usePerformanceDetailsStore } from '@/stores/performanceDetailsStore';
import { useEventPricingStore } from '@/stores/eventPricingStore';
import { useTechRiderTblStore } from '@/stores/techRiderTblStore';
import { useBillingStore } from '@/stores/billingStore';
import { useArtistDetailsStore } from '@/stores/artistDetailsStore';
import { useBookingFormsStore } from '@/stores/bookingFormsStore';
import { useJobsBidsStore } from '@/stores/jobsBidsStore';
import { useJobsLikedStore } from '@/stores/jobsLikedStore';
import { useJobsGigsStore } from '@/stores/jobsGigsStore';
import { useAwardsStore } from '@/stores/awardsStore';
import { usePastPerformancesStore } from '@/stores/pastPerformancesStore';
import { useStoryStore } from '@/stores/storyStore';
import { useUspStore } from '@/stores/uspStore';

export function clearArtistSessionCaches(): void {
  usePersonalDetailsStore.getState().reset();
  usePerformanceDetailsStore.getState().reset();
  useEventPricingStore.getState().reset();
  useTechRiderTblStore.getState().reset();
  useBillingStore.getState().reset();
  useArtistDetailsStore.getState().clearArtistDetails();
  useBookingFormsStore.getState().reset();
  useJobsBidsStore.getState().reset();
  useJobsLikedStore.getState().reset();
  useJobsGigsStore.getState().reset();
  useAwardsStore.getState().reset();
  usePastPerformancesStore.getState().reset();
  useStoryStore.getState().reset();
  useUspStore.getState().reset();
}
